<template>
  <b-container fluid>
    <div v-if="checkPermission('hospital') || checkPermission('therapy')">
      <b-overlay :show="loader">
      <iq-card>
          <template v-slot:headerTitle>
              <h4 class="card-title">{{ $t('social_service.dashbboard') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                  class="row"
                  label-cols-sm="5"
                  :label="$t('org_pro.area_type')"
                  label-for="area_type_id"
                  >
                    <b-form-select
                      plain
                      v-model="search.area_type_id"
                      :options="getHosAreaTypeList"
                      id="area_type_id"
                      >
                      <template v-slot:first>
                      <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('globalTrans.division')"
                    label-for="division_id"
                    >
                      <b-form-select
                        plain
                        v-model="search.division_id"
                        :options="divisionList"
                        id="division_id"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        <b-form-select-option :value="1000000" >{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('globalTrans.district')"
                    label-for="district_id"
                    >
                      <b-form-select
                        plain
                        v-model="search.district_id"
                        :options="districtList"
                        id="district_id"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        <b-form-select-option :value="1000000" >{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                  class="row"
                  label-cols-sm="5"
                  :label="$t('globalTrans.fiscal_year')"
                  label-for="fiscal_year"
                  >
                    <b-form-select
                      plain
                      v-model="search.fiscal_year"
                      :options="fiscalYearList"
                      id="fiscal_year"
                      >
                      <template v-slot:first>
                      <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                  class="row"
                  label-cols-sm="5"
                  :label="$t('retailerManagement.month')"
                  label-for="month"
                  >
                    <b-form-select
                      plain
                      v-model="search.month"
                      :options="monthList"
                      id="month"
                      >
                      <template v-slot:first>
                      <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                  <b-form-group
                  class="row"
                  label-cols-sm="2"
                  :label="$t('hospital_configuration.hos_name')"
                  label-for="hospital_id"
                  >
                    <v-select name="Bank"
                        v-model="search.hospital_id"
                        label="text"
                        :reduce="item => item.value"
                        :options= hospitalList
                        :placeholder="$t('globalTrans.select')"
                    />
                  </b-form-group>
                </b-col>
                <b-col class="text-right">
                  <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                </b-col>
              </b-row>
          </template>
      </iq-card>
      <b-row v-if="checkPermission('hospital')">
        <b-col md="12">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">{{ $t('hospital_configuration.hospital_service') }}</h4>
            </template>
            <template v-slot:body>
              <b-row>
                <b-col cols="4" class="custom-box-shadow">
                  <div class="hospital_dsb_card p-3 rounded mb-3 text-center">
                      <h5 class="text-white d-block">
                          {{ $t('hospital_configuration.number_patients')}}
                      </h5>
                      <h2 class="text-white">
                          <b-spinner variant="light" label="Spinning" v-if="loaderTotalRegPatient"></b-spinner>
                          <div v-else>
                              {{ $n(data.total_registered_patients) }}
                          </div>
                      </h2>
                  </div>
                </b-col>
                <b-col cols="4" class="custom-box-shadow">
                  <div class="hospital_dsb_card p-3 rounded mb-3 text-center">
                      <h5 class="text-white d-block">
                          {{ $t('hospital_configuration.free_treatment')}}
                      </h5>
                      <h2 class="text-white">
                          <b-spinner variant="light" class = "text-blue" label="Spinning" v-if="loaderTotalRegPatient"></b-spinner>
                          <div v-else>
                              {{ $n(data.total_free_treatment) }}
                          </div>
                      </h2>
                  </div>
                </b-col>
                <b-col cols="4" class="custom-box-shadow">
                  <div class="hospital_dsb_card p-3 rounded mb-3 text-center">
                      <h5 class="text-white d-block">
                          {{ $t('hospital_configuration.perce')}}
                      </h5>
                      <h2 class="text-white">
                            <b-spinner variant="light" class = "text-blue" label="Spinning" v-if="loaderTotalRegPatient"></b-spinner>
                            <div v-else>
                              {{ $n(data.total_percentage) }}
                            </div>
                      </h2>
                  </div>
                </b-col>
              </b-row>
              <br>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      </b-overlay>
    </div>
 </b-container>
</template>
<script>
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
// import { monthList } from '../../Utils/Custom'
import { totalPatients30pcApi } from '../../modules/hospital-disability-service/configuration/api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import { mapGetters } from 'vuex'

export default {
    mixins: [ModalBaseMasterList],
    components: {
    },
    data () {
        return {
            loader: false,
            loaderTotalRegPatient: true,
            loaderTotalServiceDelivery: true,
            loadTotalDonation: true,
            search: {
                hospital_id: '',
                division_id: 0,
                district_id: 0,
                upazilla_id: 0,
                category_id: '0',
                fiscal_year: '0',
                area_type_id: 0,
                month: '0',
                fiscal_year_start_date: '',
                fiscal_year_end_date: ''
            },
            item: '',
            districtList: [],
            upazilaList: [],
            data: {
                total_registered_patients: 0,
                total_free_treatment: 0,
                total_percentage: 0
            }
      }
    },
    computed: {
        formTitle () {
            return (this.editItemId === 0) ? this.$t('social_service.dashbboard') + ' ' + this.$t('globalTrans.entry') : this.$t('social_service.dashbboard') + ' ' + this.$t('globalTrans.modify')
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        getHosAreaTypeList: function () {
            const objectData = this.$store.state.ExternalUser.commonObj.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        hospitalList: function () {
          let objectData = this.$store.state.HospitalDisabilityService.commonObj.hospitalThirtyPercentList.filter(item => item.status === 1 && item.is_jointly_formated === 1)
          if (this.search.division_id < 1000000) {
            if (this.search.division_id > 0) {
                objectData = objectData.filter(item => item.division_id === this.search.division_id)
            }
          }
          if (this.search.district_id < 1000000) {
            if (this.search.district_id > 0) {
                objectData = objectData.filter(item => item.district_id === this.search.district_id)
            }
          }
          if (this.search.category_id > 0) {
              objectData = objectData.filter(item => item.category === this.search.category_id)
          }
          return objectData.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.value, text: obj.text_bn }
              } else {
                  return { value: obj.value, text: obj.text_en }
              }
          })
        },
        // monthList: function () {
        //     return this.search.fiscal_year > 0 ? monthList : []
        // },
        monthList () {
            const objectData = this.$store.state.commonObj.monthList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
                } else {
                return { value: obj.value, text: obj.text_en }
                }
            })
            },
            currentLocale () {
            return this.$i18n.locale
            },
        getHospitalCategoryList: function () {
            const objectData = this.$store.state.HospitalDisabilityService.commonObj.hospitalCategoryList.filter(item => item.id < 5)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList
        },
        ...mapGetters({
          authUser: 'Auth/authUser',
          activeRoleId: 'Auth/getActiveRole'
        })
    },
    watch: {
        'search.division_id': function (newVal, oldVal) {
            this.search.hospital_id = ''
            this.search.district_id = 0
            if (newVal < 1000000) {
              this.districtList = this.getDistrictList(newVal)
            }
        },
        'search.district_id': function (newVal, oldVal) {
            this.search.hospital_id = ''
            this.upazilaList = this.getUpazilaList(newVal)
        },
        'search.fiscal_year': function (newVal, oldVal) {
            if (newVal !== 0) {
                const fiscalYearId = parseInt(newVal)
                const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
                this.search.fiscal_year_start_date = fiscalYear.start_date
                this.search.fiscal_year_end_date = fiscalYear.end_date
            } else {
                this.search.fiscal_year_start_date = null
                this.search.fiscal_year_end_date = null
            }
      }
    },
    created () {
        this.loadData()
    },
    methods: {
        searchData () {
            this.loadData()
        },
        loadData () {
            // const fiscalYear = this.yearOfRegistration.find(item => item.value === this.search.fiscal_year).text
            this.loader = true
            this.loaderTotalRegPatient = true
            const params = Object.assign({}, this.search)
            RestApi.getData(hospitalServiceBaseUrl, totalPatients30pcApi, params).then(response => {
                if (response.success) {
                    this.data = response.data
                }
                this.loaderTotalRegPatient = false
            })
            this.loader = false
        },
        getDistrictList (divisionId = null) {
            const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

            if (divisionId) {
                return districtList.filter(district => district.division_id === divisionId)
            }

            return districtList
        },
        getUpazilaList (districtId = null) {
            const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

            if (districtId) {
                return upazilaList.filter(upazila => upazila.district_id === districtId)
            }

            return upazilaList
        },
        checkPermission (type = 'hospital') {
          if (this.authUser.org_id !== 1 && this.authUser.is_org_admin === 0) {
            return false
          }
          if (type === 'hospital' && [1, 2].indexOf(this.authUser.org_id) !== -1) {
            return true
          } else if (type === 'therapy' && [1, 3].indexOf(this.authUser.org_id) !== -1) {
            return true
          }
          return false
        }
    }
}
</script>
